import { render, staticRenderFns } from "./Ascendante.vue?vue&type=template&id=97529c94&scoped=true"
import script from "./Ascendante.vue?vue&type=script&lang=js"
export * from "./Ascendante.vue?vue&type=script&lang=js"
import style0 from "./Ascendante.vue?vue&type=style&index=0&id=97529c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97529c94",
  null
  
)

export default component.exports